export const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  button: {
    cursor: "pointer",
    margin: "12px",
    // paddingBottom: theme.spacing(2),
    // paddingTop: theme.spacing(2),
  },
  btnBottom: {
    marginTop: theme.spacing(4),
  },
  logo: {
    cursor: "pointer",
    width: "40%",
    maxWidth: 150,
    marginBottom: theme.spacing(6),
  },
  inputTypeEmployee: {
    textTransform: "capitalize",
  },
  menuItem: {
    fontSize: "0.8rem",
  },
});
